<app-modal-template
	[title]="'Download Roles'"
	(cancelClicked)="cancel()"
	(saveClicked)="downloadFile()"
	[showCancel]="false"
	[saveText]="'Download'"
	[saveIcon]="['fass', 'arrow-to-bottom']"
>
	<p>Click the button below to download a list of roles in .CSV format.</p>
</app-modal-template>
